import React from "react";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import CroField from "../../../generalForm/CroField";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { fieldsRemove } from "../../../../CroUtils";
import * as V from "../../../../../../utils/formValidation";
import { isNil } from "lodash";
import Help from "../../../Help";
import H from "../../../../helpEnum";

export default ({
  fields,
  disabled,
  canAddMore,
  officialId,
  deputyStatement,
  isAdmin,
  onChangeFunction,
  versionChangedClass
}) => {
  const url = !isNil(officialId)
    ? isAdmin
      ? `/administrator/api/funkcionari/zastava/${officialId}`
      : `/funkcionar/api/profil/zastava/${officialId}`
    : "/api/ciselniky/funkce/doplneni/vse";

  if (fields.length === 0) {
    fields.push({});
  }
  return (
    <div className="cro-array-container">
      {fields.map((item, index) => (
        <div key={index} className={`cro-array-item higher ${versionChangedClass ? versionChangedClass(`${item}`) : ""}`}>
          {canAddMore && !disabled && fields.length > 1 && (
            <CroRemoveButton onClick={fieldsRemove(fields, index, 1)} />
          )}
          <div
            className="cro-array-item-content"
            style={{ flex: 1, minWidth: 0 }}
          >
            <div className="statementForm__arrayGrid">
              <div className="statementForm__arrayFull">
                <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}`) : ""}
                    title="Funkce a datum zahájení"
                    name={`${item}`}
                    component={AutoComplete}
                    fullWidth
                    inputStyle={{ width: "100%" }}
                    disabled={disabled}
                    url={url}
                    validate={[V.required, V.isDictionary]}
                    onChange={onChangeFunction}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
      {canAddMore && !disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => fields.push({})} />
          <Help helpEnum={H.ADD_REMOVE_WP.r} />
        </div>
      )}
    </div>
  );
};
